module.exports = __webpack_public_path__ + "img/material-symbols_check-circle-partially.e9810f1a.svg";